var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found-page"},[_c('a-result',{attrs:{"status":"404","title":"404","sub-title":"页面不存在"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }